const sortByOrder = (items) =>
  [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

const moveToGroupEnd = (items, sectionId) => {
  const itemIndex = items.findIndex((item) => item.id === sectionId);

  if (itemIndex < 0) return items;

  const [item] = items.splice(itemIndex, 1);
  items.push(item);

  return items;
};

const reorderSectionsByVisibility = (sections, sectionId, newIsVisible) => {
  const visibleSections = sortByOrder(
    sections.filter((sectionItem) => sectionItem.visible)
  );
  const hiddenSections = sortByOrder(
    sections.filter((sectionItem) => !sectionItem.visible)
  );

  if (newIsVisible) {
    moveToGroupEnd(visibleSections, sectionId);
  } else {
    moveToGroupEnd(hiddenSections, sectionId);
  }

  return [...visibleSections, ...hiddenSections].map((sectionItem, index) =>
    sectionItem.order === index
      ? sectionItem
      : { ...sectionItem, order: index, dirty: true }
  );
};

export default reorderSectionsByVisibility;
